import styled, { css } from 'styled-components';

import { Card, Text, Checkbox } from '@gympass/yoga';

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TextContainer = styled.div`
  flex: 1;
`;

const disabledState = css`
  color: ${({ theme }) => theme.yoga.colors.textDisabled} !important;
`;

export const CardHeader = styled(Text.H5)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxsmall}px;

  ${({ disabled }) =>
    disabled &&
    css`
      ${disabledState}
    `};
`;

export const CardContent = styled(Text.Small)`
  ${({ disabled }) =>
    disabled &&
    css`
      ${disabledState}
    `};
`;

export const StyledSwitch = styled(Checkbox.Switch)`
  ${({ theme, checked }) =>
    checked &&
    css`
      background-color: ${theme.yoga.colors.primaryLight} !important;
    `};
`;
